<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> RELATÓRIO DE PEDIDOS </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      >
      </alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid v-if="loadingSession">
          <v-row>
            <v-col>
              <label>&nbsp;</label>
              <v-select
                :items="status"
                :item-text="(item) => `${item.name}`"
                item-value="status"
                v-model="filter.status"
                label="Situação"
                dense
                hide-details
                outlined
                multiple
                small-chips
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @mousedown.prevent @click="toggle">
                    <v-list-item-action>
                      <v-icon
                        :color="status.length > 0 ? 'indigo darken-4' : ''"
                      >
                        {{ iconSelectStatus }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title> Todos </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:selection="{ item, index }">
                  <span
                    v-if="filter.status.length === status.length && index === 0"
                    >Todos</span
                  >
                  <span
                    v-if="filter.status.length !== status.length && index === 0"
                    >{{ item.name }} &nbsp;</span
                  >
                  <span
                    v-if="filter.status.length !== status.length && index === 1"
                    class="text-caption"
                  >
                    [ +{{ filter.status.length - 1 }} outro(s) ]
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col v-if="companySelected.type !== 'for'">
              <label>&nbsp;</label>
              <v-autocomplete
                :items="providers"
                label="Fornecedor"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="filter.provider"
                :loading="loadingProvider"
                dense
                hide-details
                outlined
                multiple
                small-chips
                clearable
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip
                    color="blue darken-2"
                    class="white--text"
                    label
                    small
                    v-if="index === 0"
                  >
                    <span
                      >{{ item.code }} -
                      {{ item.name.substring(0, 15) }}...</span
                    >
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ filter.provider.length - 1 }})
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col
              v-if="
                companySelected.type !== 'fra' && companySelected.type !== 'mul'
              "
            >
              <label>&nbsp;</label>
              <v-autocomplete
                :items="franchises"
                label="Franquia"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="filter.franchise"
                :loading="loadingProvider"
                dense
                hide-details
                outlined
                clearable
                multiple
                small-chips
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip
                    color="blue darken-2"
                    class="white--text"
                    label
                    small
                    v-if="index === 0"
                  >
                    <span
                      >{{ item.code }} -
                      {{ item.name.substring(0, 15) }}...</span
                    >
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ filter.franchise.length - 1 }})
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col>
              <v-row>
                <v-col>
                  <label>Valor Pedido</label>
                  <v-text-field
                    v-model="filter.value_min"
                    label="de"
                    dense
                    outlined
                    hide-details
                    v-mask="'money'"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <label>&nbsp;</label>
                  <v-text-field
                    v-model="filter.value_max"
                    label="até"
                    dense
                    outlined
                    hide-details
                    v-mask="'money'"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col v-if="companySelected.type !== null"></v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-row>
                <v-col>
                  <label>Emissão</label>
                  <v-text-field
                    v-model="filter.issuance_date_min"
                    label="de"
                    dense
                    outlined
                    hide-details
                    v-mask="date_mask"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <label>&nbsp;</label>
                  <v-text-field
                    v-model="filter.issuance_date_max"
                    label="até"
                    dense
                    outlined
                    hide-details
                    v-mask="date_mask"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-row>
                <v-col>
                  <label>Estimativa</label>
                  <v-text-field
                    v-model="filter.estimate_date_min"
                    label="de"
                    dense
                    outlined
                    hide-details
                    v-mask="date_mask"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <label>&nbsp;</label>
                  <v-text-field
                    v-model="filter.estimate_date_max"
                    label="até"
                    dense
                    outlined
                    hide-details
                    v-mask="date_mask"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <label>&nbsp;</label>
              <v-select
                :items="orderByOptions"
                label="Ordenar Relatório por:"
                dense
                hide-details
                outlined
                v-model="filter.orderBy"
              ></v-select>
            </v-col>
            <v-col v-if="false">
              <label>&nbsp;</label>
              <v-select
                :items="reportTypes"
                label="Tipo Relatório"
                dense
                hide-details
                outlined
                v-model="filter.reportType"
              ></v-select>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-7 mr-10"
                @click="getOrders()"
              >
                Executar Consulta
              </v-btn>
              <v-btn
                :disabled="providersOrders.length == 0"
                @click="exportReport('pdf')"
                color="grey darken-4"
                outlined
                small
                class="mt-7 mr-2"
              >
                <v-icon color="red" left> mdi-file-pdf-box </v-icon>
                PDF
              </v-btn>
              <v-btn
                :disabled="providersOrders.length == 0"
                @click="exportReport('excel')"
                color="grey darken-4"
                outlined
                small
                class="mt-7"
              >
                <v-icon color="green" left> mdi-file-excel-box </v-icon>
                Excel
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card elevation="0" v-if="providersOrders.length == 0">
                <v-card-title
                  class="d-flex justify-center grey--text text-subtitle-1"
                  >Execute a consulta para poder ver o relatório</v-card-title
                >
              </v-card>
              <v-card
                v-for="provider in providersOrders"
                :key="provider.provider_id"
              >
                <!-- <v-card-title> Nutrition </v-card-title> -->
                <v-data-table
                  dense
                  :headers="headers"
                  :items="provider.orders"
                  :sort-by="getFieldSortBy()"
                  :sort-desc="getSortDescBy()"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title
                        >{{ provider.provider_code }} -
                        {{ provider.provider_name }}</v-toolbar-title
                      >
                    </v-toolbar>
                  </template>
                  <template
                    v-if="provider.orders.length > 0"
                    v-slot:body.append
                  >
                    <tr>
                      <td colspan="4" class="text-right text-subtitle-2 pa-4">
                        Total Fornecedor
                      </td>
                      <td class="text-right text-subtitle-2">
                        {{ getTotal(provider.orders, "quantity_products") }}
                      </td>
                      <td class="text-right text-subtitle-2">
                        {{ getTotal(provider.orders, "quantity_items") }}
                      </td>
                      <td class="text-right text-subtitle-2">
                        {{ getTotal(provider.orders, "quantity_served") }}
                      </td>
                      <td class="text-right text-subtitle-2">
                        {{ getTotal(provider.orders, "quantity_outstanding") }}
                      </td>
                      <td class="text-right text-subtitle-2">
                        {{
                          getTotal(provider.orders, "value") | currencyEuaToBr
                        }}
                      </td>
                      <td></td>
                    </tr>
                  </template>
                  <!-- eslint-disable-next-line -->
                  <template v-slot:item.status="{ item }">
                    {{ getName(item.status) }}
                  </template>
                  <!-- eslint-disable-next-line -->
                  <template v-slot:item.franchise.name="{ item }">
                    {{ item.franchise.code }} - {{ item.franchise.name }}
                  </template>
                  <!-- eslint-disable-next-line -->
                  <template v-slot:item.issuance_date="{ item }">
                    {{ item.issuance_date | dateFormatBr }}
                  </template>
                  <!-- eslint-disable-next-line -->
                  <template v-slot:item.estimate_date="{ item }">
                    {{ item.estimate_date | dateFormatBr }}
                  </template>
                  <!-- eslint-disable-next-line -->
                  <template v-slot:item.value="{ item }">
                    {{ item.value | currencyEuaToBr }}
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="linkDownload"
    >
      <v-card>
        <v-card-text class="pa-10">
          <v-btn
            class="ma-5 white--text justify-center d-flex"
            large
            color="indigo"
            target="_blank"
            :href="download.link"
            @click="() => (linkDownload = false)"
          >
            <v-icon left>mdi-cloud-download</v-icon>
            CLIQUE AQUI PARA BAIXAR
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="linkDownload = false">
            FECHAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="dialogSelectPdfType"
    >
      <v-card>
        <v-card-title> Relatório empresa </v-card-title>
        <v-card-text class="pa-5">
          <p>Selecione o tipo de relatório das empresas em PDF</p>
          <v-btn
            class="ma-5 justify-center"
            large
            outlined
            :disabled="disableTypeTable"
            color="indigo"
            @click="exportReport('pdf')"
          >
            <v-icon left>mdi-file-table-outline</v-icon>
            Tabela
          </v-btn>
          <v-btn
            class="ma-5 justify-center"
            large
            outlined
            color="green darken-3"
            @click="exportReport('pdf-data-company')"
          >
            <v-icon left>mdi-file-document-multiple-outline</v-icon>
            Ficha
          </v-btn>
          <p class="text-caption blue--text mt-5">
            O tipo Tabela só é liberado para relatório com menos de 10 colunas
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogSelectPdfType = false">
            FECHAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";
import * as HTTP from "@/api/requests/base";
import Alert from "@/components/Alert";
import * as CompanyAPI from "@/api/requests/CompanyRequest";
import { ORDER_STATUS, getStatusName } from "@/helpers/order_status";
import AwesomeMask from "awesome-mask";

export default {
  components: { Alert },
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    date_mask: "99/99/9999",
    franchises: [],
    orders: [],
    providersOrders: [],
    providers: [],
    status: [],
    filter: {
      status: [],
      type: "admin",
      franchise: [],
      provider: [],
      reportType: "S",
      orderBy: "emissao_desc",
      value_min: "0.00",
      value_max: "",
      estimate_date_max: "",
      estimate_date_min: "",
      issuance_date_min: "",
      issuance_date_max: "",
    },
    reportTypes: [
      {
        value: "S",
        text: "Sintético",
      },
      {
        value: "A",
        text: "Analítico",
      },
    ],
    disabledOptions: [
      { value: 1, text: "Não" },
      { value: 2, text: "Sim" },
      { value: 3, text: "Todos" },
    ],
    orderByOptions: [
      {
        value: "emissao_desc",
        text: "Emissão Decrescente",
        sortHeader: { field: "issuance_date", sortDesc: true },
      },
      {
        value: "emissao_asc",
        text: "Emissão Crescente",
        sortHeader: { field: "issuance_date", sortDesc: false },
      },
      {
        value: "codigo_asc",
        text: "Código Crescente",
        sortHeader: { field: "fullCode", sortDesc: false },
      },
      {
        value: "codigo_desc",
        text: "Código Decrescente",
        sortHeader: { field: "fullCode", sortDesc: true },
      },
      {
        value: "franquia",
        text: "Franquia",
        sortHeader: { field: "franchise.name", sortDesc: false },
      },
      {
        value: "Situação",
        text: "Situação",
        sortHeader: { field: "status", sortDesc: false },
      },
    ],
    headers: [
      {
        text: "Código",
        align: "left",
        value: "fullCode",
        width: 120,
      },
      { text: "Franquia", value: "franchise.name", width: 300 },
      { text: "Emissão", value: "issuance_date", width: 80 },
      { text: "Estimativa", value: "estimate_date", width: 80 },
      {
        text: "Produtos",
        align: "right",
        value: "quantity_products",
        width: 100,
      },
      {
        text: "Qt. Pedida",
        align: "right",
        value: "quantity_items",
        width: 100,
      },
      {
        text: "Qt. Atendida",
        align: "right",
        value: "quantity_served",
        width: 100,
      },
      {
        text: "Qt. Pendente",
        align: "right",
        value: "quantity_outstanding",
        width: 100,
      },
      { text: "Valor", align: "right", value: "value", width: 100 },
      { text: "Situação", value: "status", width: 200 },
    ],
    loading: false,
    successSave: false,
    lazy: false,
    valid: true,
    showAlert: false,
    loadingSession: false,
    typeAlert: "error",
    messageAlert: "",
    yesOrNo: [
      {
        value: "y",
        text: "Sim",
      },
      {
        value: "n",
        text: "Não",
      },
    ],
    linkDownload: false,
    download: {
      name: "",
      link: "#",
    },
    showAddress: true,
    dialogSelectPdfType: false,
    disableTypeTable: true,
    companySelected: {
      type: null,
    },
  }),
  computed: {
    allStatusSelected() {
      return this.status.length === this.filter.status.length;
    },
    someStatusSelected() {
      return this.filter.status.length > 0 && !this.allStatusSelected;
    },
    iconSelectStatus() {
      if (this.allStatusSelected) return "mdi-close-box";
      if (this.someStatusSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.status = ORDER_STATUS;
      this.filter.status = ORDER_STATUS.map((item) => item.status);
      this.getCompanies();
      this.getSession();
    },
    toggle() {
      this.$nextTick(() => {
        if (this.allStatusSelected) {
          this.filter.status = [];
        } else {
          this.filter.status = this.status.map((item) => item.status);
        }
      });
    },
    getSession() {
      let session = localStorage.getItem(HTTP.COMMON_LOCAL_STORAGE_KEY);
      if (session) {
        session = JSON.parse(session);
        console.log(session);
        if (typeof session["company_selected"] !== "undefined") {
          this.companySelected = session.company_selected;
          this.$nextTick(() => {
            if (this.companySelected.type === "for") {
              this.status = ORDER_STATUS.filter(
                (item) =>
                  item.status === "validated_franchisor" ||
                  item.status === "confirmed_supplier" ||
                  item.status === "refused_supplier" ||
                  item.status === "invoiced_supplier"
              );

              let index = this.status.findIndex(
                (item) => item.status === "validated_franchisor"
              );
              this.status[index].name = "Aguardando Confirmação";

              this.filter.status = this.status.map((item) => item.status);
              this.filter.provider = [this.companySelected.id];
              this.filter.type = "for";
            } else if (
              this.companySelected.type === "fra" ||
              this.companySelected.type === "mul"
            ) {
              this.status = ORDER_STATUS.filter(
                (item) =>
                  item.status !== "partial_reconciled" &&
                  item.status !== "reconciled"
              );

              this.filter.status = this.status.map((item) => item.status);
              this.filter.franchise = [this.companySelected.id];
              this.filter.type = "fra";
            }
          });
        }

        this.loadingSession = true;
        // if (session.user !== "") {
        //   this.name = session.user.name.toUpperCase();
        //   this.typeUser = session.user.type;
        //   if (this.typeUser === "admin") {
        //     this.getCompanies();
        //   }
        // }
      } else {
        this.loadingSession = true;
      }
    },
    validate() {},
    async getCompanies() {
      this.loadingProvider = true;
      try {
        let res = await CompanyAPI.getAll();
        this.providers = res
          .filter((item) => item.type == "for")
          .sort((a, b) => (a.name < b.name ? -1 : 1));
        this.franchises = res
          .filter((item) => item.type != "for")
          .sort((a, b) => (a.name < b.name ? -1 : 1));
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingProvider = false;
      }
    },
    async getOrders() {
      this.showAlert = false;
      this.loading = true;
      this.orders = [];
      let data = this.filter;
      try {
        let response = await fetch(`${URL}order/report`, {
          method: "POST",
          body: JSON.stringify(data),
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        });
        let res = await response.json();
        this.providersOrders = [];
        res.map((item) => {
          const fullCode = `${item.franchise.code} - ${item.code}`;

          const index = this.providersOrders.findIndex(
            (po) => po.provider_id === item.provider_id
          );
          if (index > -1) {
            this.providersOrders[index].orders.push({
              ...item,
              fullCode,
            });
          } else {
            this.providersOrders.push({
              provider_id: item.provider_id,
              provider_name: item.provider.name,
              provider_code: item.provider.code,
              orders: [
                {
                  ...item,
                  fullCode,
                },
              ],
            });
          }
        });
        this.providersOrders = this.providersOrders.sort((a, b) =>
          a.provider_name < b.provider_name ? -1 : 1
        );
        // this.orders = res
        //   .sort((a, b) => (a.code < b.code ? -1 : 1))
        //   .sort((a, b) => (a.franchise.name < b.franchise.name ? -1 : 1));
      } catch (error) {
        this.messageAlert =
          "Não foi possível carregar os Pedidos, tente novamente mais tarde";
        this.typeAlert = "error";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    getName(status) {
      return getStatusName(status);
    },
    async exportReport(type) {
      // return false;
      this.loading = true;
      this.dialogSelectPdfType = false;
      this.download = {
        name: "",
        link: "#",
      };
      this.linkDownload = false;
      let data = {};
      data.providers = this.providersOrders;

      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}order/report/${type}`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        this.download.name = response.nome;
        this.download.link = `${URL}order/download/${response.nome}`;
        this.linkDownload = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    getTotal(data, field) {
      if (field === "value") {
        return data
          .map((item) => item[field])
          .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
      }
      return data
        .map((item) => item[field])
        .reduce((a, b) => parseInt(a) + parseInt(b), 0);
    },
    getFieldSortBy() {
      let option = this.orderByOptions.find(
        (item) => item.value === this.filter.orderBy
      );
      return option.sortHeader.field;
    },
    getSortDescBy() {
      let option = this.orderByOptions.find(
        (item) => item.value === this.filter.orderBy
      );
      return option.sortHeader.sortDesc;
    },
  },
};
</script>
<style scoped>
.v-data-table {
  overflow-x: auto;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}

.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>
<style>
.text-area-uppercase textarea {
  text-transform: uppercase;
}
</style>
